import $ from 'jquery';

export class bioShow {
	
		constructor() {
			$('.js-toggle-bio').click(function() {
				var bio = $(this).attr('data-bio');
				$('.'+bio).slideToggle();
				$(this).toggleClass('open');
				if($(this).hasClass('open')) {
					$(this).html('-');
				}
				else {
					$(this).html('+');
				}

			})
		}
	
}

